export default __webpack_public_path__ + "static/clandestinna-balthazaurus-scroll-04b2de31940a58fdbefe431b67e12767.gif";